import { v4 } from "uuid";

const CARD = "cards/CARD";
const CARD_ERROR = "cards/CARD_ERROR";
const CARD_SUCCESS = "cards/CARD_SUCCESS";
const CARDS = "cards/CARDS";
const CARDS_ERROR = "cards/CARDS_ERROR";
const CARDS_SUCCESS = "cards/CARDS_SUCCESS";

const initialState = { activeRequests: [], cards: {}, error: "", isLoading: false };

const cards = (state = initialState, action) => {
  switch (action.type) {
    case CARD: {
      return {
        ...state,
        cards: { ...state.cards, [action.url]: { loading: true } },
      };
    }
    case CARD_ERROR: {
      return state;
    }
    case CARD_SUCCESS: {
      return {
        ...state,
        cards: { ...state.cards, [action.data.url]: action.data },
      };
    }
    case CARDS: {
      return { ...state, activeRequests: [...state.activeRequests, action.requestId], error: "", isLoading: true };
    }
    case CARDS_ERROR:
    case CARDS_SUCCESS: {
      const activeRequests = state.activeRequests.filter((id) => id !== action.requestId);
      const newState = {
        ...state,
        activeRequests,
        isLoading: activeRequests.length > 0,
      };
      if (action.type === CARDS_ERROR) {
        newState.error = action.error;
      } else if (action.type === CARDS_SUCCESS) {
        newState.cards = { ...state.cards, ...action.data.cards };
      }
      return newState;
    }
    default: {
      return state;
    }
  }
};

export const addCards = (names) => async (dispatch, getState) => {
  const requestId = v4();
  dispatch({ names, requestId, type: CARDS });
  try {
    const res = await fetch(`/api/cards/`, {
      body: JSON.stringify({ format: "dict", names }),
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
    });
    const data = await res.json();
    if (res.status !== 200) {
      return dispatch({ error: data.message, requestId, type: CARD_ERROR });
    }
    return dispatch({ data, requestId, type: CARDS_SUCCESS });
  } catch (e) {
    return dispatch({ error: e.message, requestId, type: CARDS_ERROR });
  }
};

export const addCardsFromRecs = (recs) => ({
  data: { cards: Object.fromEntries(recs.inRecs.map((card) => [card.url, card])) },
  type: CARDS_SUCCESS,
});

export const addCard = (url) => async (dispatch) => {
  dispatch({ type: CARD, url });
  try {
    const res = await fetch(`https://json.edhrec.com/cards/${url}`);
    const data = await res.json();
    if (res.status !== 200) {
      return dispatch({ error: data.message, type: CARD_ERROR });
    }
    return dispatch({ data, type: CARD_SUCCESS });
  } catch (e) {
    return dispatch({ error: e.message, type: CARD_ERROR });
  }
};

export default cards;
